import React, { useState, useRef, useEffect } from "react";
import "../styles/Otp.css";
import ills from "../image/illustrate.png";
import illsMobile from "../image/illustration.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom"; 
import axios from "axios";
import Loader from "./Loader";

const Otp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation(); 
  useEffect(() => {
    const email = sessionStorage.getItem("userEmail") || location.state?.email;
    if (email) {
      setUserEmail(email);
    }
  }, [location.state]);

  const handleChange = (index, value) => {
    if (isNaN(value)) return;

    let newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleVerifyOtp = async () => {
    setIsLoading(true);
    setError(null);
  
    try {
      const otpCode = otp.join("");
  
      const response = await axios.post("https://api.nexcard.co.in/api/otp/verify/", {
        email: userEmail,
        otp: otpCode,
      });
  
      console.log("OTP verification successful:", response.data);
  
      // Modified: After successful signup, redirect to login page
      navigate("/login", { 
        state: {
          ...location.state, // Pass through all state
          email: userEmail,
          isHolderShare: location.state?.isHolderShare
        }
      });
    } catch (error) {
      console.error("OTP verification failed:", error);
      setError(error.response?.data?.message || "OTP verification failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setIsLoading(true);
    setError(null);

    try {
      await axios.post("https://api.nexcard.co.in/api/otp/resend/", {
        email: userEmail,
      });
      alert("OTP has been resent successfully!");
    } catch (error) {
      console.error("Failed to resend OTP:", error);
      setError("Failed to resend OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-left">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <div className="mobile-illustration">
          <img src={illsMobile} alt="Mobile Illustration" />
        </div>
        <h1>Verify OTP</h1>
        <p className="otp-para">
          Please enter the <b>One time Password</b> we just sent to your<br />
          E-mail ID <b>{userEmail}</b>
        </p>
        <div className="otp-form">
          <div className="otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
              />
            ))}
          </div>
          {error && <p className="error-message">{error}</p>}
          <button 
            className="sign-up-btnotp" 
            onClick={handleVerifyOtp} 
            disabled={isLoading || otp.some(digit => digit === "")}
          >
            {isLoading ? <Loader small /> : "Verify OTP"}
          </button>
        </div>
        <p className="resend-otp">
          Didn't receive OTP? <br /> <br />
          <b className="resend" onClick={handleResendOtp} style={{ cursor: 'pointer' }}>
            Resend code
          </b>
        </p>
      </div>
      <div className="otp-divider"></div>
      <div className="otp-right">
        <img src={ills} alt="Background Illustration" className="background-image" />
      </div>
    </div>
  );
};

export default Otp;